<template>
  <div id="app">
    <Stonks/>
  </div>
</template>

<script>
import Stonks from './components/Stonks.vue'

export default {
  name: 'App',
  components: {
    Stonks
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
